import { QuestionCircleFilled } from "@ant-design/icons"
import { Tooltip } from "antd"
import TextArea from "antd/es/input/TextArea"
import { useEffect, useState } from "react"
import { t } from "../../../languages/i18n"

interface FacebookProp {
  setFacebookAppId: (facebookId: string) => void
  facebookAppId: string
}

const FacebookAppID: React.FC<FacebookProp> = ({ setFacebookAppId, facebookAppId }) => {
  const [facebookId, setFacebookId] = useState<string>("")
  const handleChange = (e: any) => {
    setFacebookId(e.target.value)
    setFacebookAppId(e.target.value)
  }
  useEffect(() => {
    setFacebookId(facebookAppId)
  }, [facebookAppId])
  return (
    <div className="w-full flex flex-row gap-4 border-b pb-8">
      <div className="w-2/5 flex flex-col gap-2 ">
        <h2 className="text-base font-semibold">Facebook App ID</h2>
        <p>{t("Paste your Facebook App ID code")}</p>
      </div>
      <div className=" w-3/5 flex flex-col gap-2 bg-white drop-shadow-md p-4 rounded-lg align-top">
        <div className="flex flex-row gap-2">
          <h2>Facebook App ID</h2>
          <Tooltip title="Hướng dẫn thiết lập">
            <QuestionCircleFilled style={{ fontSize: 18 }} />
          </Tooltip>
        </div>
        <TextArea
          onChange={handleChange}
          value={facebookId}
          placeholder={t("Paste your Facebook App ID code here")}
          autoSize={{ minRows: 2, maxRows: 6 }}
        />
      </div>
    </div>
  )
}

export default FacebookAppID
